import { IOpeningTime, ITimes } from 'src/types/venue.types';
import { DAYS } from 'src/constants';
import { TEditVenueOpeningTimes } from '../../types';

export const createOpeningTimes = (times: IOpeningTime[]): TEditVenueOpeningTimes => {
  const openingTimes: TEditVenueOpeningTimes = {
    FRIDAY: [],
    MONDAY: [],
    SATURDAY: [],
    SUNDAY: [],
    THURSDAY: [],
    TUESDAY: [],
    WEDNESDAY: [],
  };
  DAYS.forEach((day) => {
    const currentOpeningTimes = times?.find((selectedDay) => selectedDay.dayOfWeek === day);
    if (currentOpeningTimes) {
      const formattedOpeningTimes = currentOpeningTimes?.times.map((time: ITimes) => ({
        start: time.startTime,
        end: time.endTime,
        openingTimeId: time.openingTimeId,
      }));
      openingTimes[day] = formattedOpeningTimes;
    }
  });
  return openingTimes;
};

export default createOpeningTimes;
